import React, {Component, ReactNode} from 'react';
import {CustomFilterField, CustomFilterLiteralSearch} from "../../../domain/ui/FilterDomains";
import {OverlayPanel} from "primereact/overlaypanel";
import DataType from "../../../constant/DataType";
import CustomFilterStringLiteralComponent from "./CustomFilterStringLiteralComponent";
import CustomFilterNumericLiteralComponent from "./CustomFilterNumericLiteralComponent";
import CustomDismissible from "../CustomDismissible";
import Icon from 'icons/Icon';
import LanguageUtil from 'util/LanguageUtil';

class CustomFilterLiteralComponent extends Component<Props> {
  private literalEditorOverlayPanel: OverlayPanel | null = null;

  public render() {
    const {field, id, onRemove, onToggle} = this.props;
    return (
      <CustomDismissible id={id} onDismiss={() => this.literalEditorOverlayPanel?.hide()}>
        <div id={id}>
          <OverlayPanel appendTo="self" ref={r => this.literalEditorOverlayPanel = r}>
            {this.getEditorComponent()}
          </OverlayPanel>
          <div
            className={`inline-flex shrink-0 items-center h-[32px]  border-[1px]  bg-[#458EF714] rounded-[4px] box-border text-[#458EF7] border-[#458EF7] ${field.enabled ? "" : "opacity-40"}`}>
            <div
              id={`filter-toggle-${id}`}
              className="flex cursor-pointer w-full items-center justify-between  gap-x-1 z-10 px-2 max-w-[400px] overflow-x-scroll"
              onClick={(e) => {
                this.literalEditorOverlayPanel?.toggle(e, e.currentTarget)
              }}>
              <div className={"flex gap-x-1 w-full shrink-0"}>
                <p className={"flex items-center  shrink-0 font-semibold"}>{field.label}</p>
                <p className={"flex items-center  shrink-0"}>{this.getOperator((field.search.value as CustomFilterLiteralSearch).operator)}</p>
                <p className={"flex items-center  shrink-0"}>{this.getDisplayValue(field)}</p>
              </div>
            </div>
            <div className={"flex cursor-pointer shrink-0 "}>
              <Icon size={20} onClick={onToggle} className={"opacity-80 hover:opacity-100"} icon={field.enabled ? "visibility" : "visibility_off"}/>
            </div>
            <div className={"flex cursor-pointer shrink-0 "}>
              <Icon size={20} onClick={onRemove} className={"opacity-80 hover:opacity-100"} icon={"close"}/>
            </div>
          </div>
        </div>
      </CustomDismissible>
    );
  }

  private getDisplayValue = (field: CustomFilterField): string | number => {
    const search = field.search.value as CustomFilterLiteralSearch;
    const isEmpty = search.value === undefined || search.value === null || search.value === '';
    if (isEmpty && field.emptyMeansNone) {
      return LanguageUtil.get({ id: 'common.label.none', defaultMessage: 'None' });
    }
    return search.value;
  }

  private getOperator = (operator: string) => {
    switch (operator) {
      case "eq":
        return <Icon icon={"equal"} size={14}/>
      case "neq":
        return <Icon icon={"not-equal"} size={14}/>
      case "gt":
        return <Icon icon={"greater-than"} size={14}/>
      case "gte":
        return <Icon icon={"greater-than-or-equals"} size={14}/>
      case "lt":
        return <Icon icon={"less-than"} size={14}/>
      case "lte":
        return <Icon icon={"less-than-or-equals"} size={14}/>
      case "contains":
        return <Icon icon={"expression_icon_contains"} size={20}/>
      case "regex":
        return <Icon icon={"expression_icon_matches"} size={20}/>
    }
  }

  private getEditorComponent = (): ReactNode => {
    const {field, onChange} = this.props;
    switch ((field.search.value as CustomFilterLiteralSearch).properties.dataType) {
      case DataType.STRING:
        return <CustomFilterStringLiteralComponent field={field} onChange={onChange}
                                                   onApply={this.applyFilter}/>
      case DataType.NUMBER:
        return <CustomFilterNumericLiteralComponent field={field} onChange={onChange}
                                                    onApply={this.applyFilter}/>
    }
  }

  private applyFilter = () => {
    const {onApply} = this.props;
    onApply()
    this.literalEditorOverlayPanel?.hide();
  }
}

interface Props {
  id: string;
  field: CustomFilterField;
  onChange: () => void;
  onApply: () => void;
  onRemove: () => void;
  onToggle: () => void;
}

export default CustomFilterLiteralComponent;
